import React, { FC } from 'react'
import Skeleton from 'react-loading-skeleton'

const SkeletonHOC: ({ width, height }) => FC<{}> =
  ({ width, height }) =>
  () => {
    return <Skeleton width={width} height={height} />
  }

export default SkeletonHOC
